// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { type CustomContentProps, SnackbarContent, closeSnackbar } from 'notistack';
import * as React from 'react';
import { Alert } from '../../../lib/base';

type ReportCompleteProps = CustomContentProps;

export const SuccessSnackbar = React.forwardRef<HTMLDivElement, ReportCompleteProps>((props, ref) => {
  const {
    // You have access to notistack props and options 👇🏼
    id,
    message,
    // as well as your own custom props 👇🏼
    // ...other
  } = props;

  return (
    <SnackbarContent ref={ref} role="alert">
      <Alert
        severity="success"
        sx={{ width: '100%' }}
        onClose={() => {
          closeSnackbar(id);
        }}
      >
        {message}
      </Alert>
    </SnackbarContent>
  );
});

export const ErrorSnackbar = React.forwardRef<HTMLDivElement, ReportCompleteProps>((props, ref) => {
  const {
    // You have access to notistack props and options 👇🏼
    id,
    message,
    // as well as your own custom props 👇🏼
    // ...other
  } = props;
  const realMessage =
    typeof message === 'string' && message.startsWith('CLIENT:') ? message.substring('CLIENT:'.length) : message;

  return (
    <SnackbarContent ref={ref} role="alert">
      <Alert
        severity="error"
        sx={{ width: '100%' }}
        onClose={() => {
          closeSnackbar(id);
        }}
      >
        {realMessage}
      </Alert>
    </SnackbarContent>
  );
});

export const InfoSnackbar = React.forwardRef<HTMLDivElement, ReportCompleteProps>((props, ref) => {
  const {
    // You have access to notistack props and options 👇🏼
    id,
    message,
    // as well as your own custom props 👇🏼
    // ...other
  } = props;

  return (
    <SnackbarContent ref={ref} role="alert">
      <Alert
        severity="info"
        sx={{ width: '100%' }}
        onClose={() => {
          closeSnackbar(id);
        }}
      >
        {message}
      </Alert>
    </SnackbarContent>
  );
});

export const WarningSnackbar = React.forwardRef<HTMLDivElement, ReportCompleteProps>((props, ref) => {
  const {
    // You have access to notistack props and options 👇🏼
    id,
    message,
    // as well as your own custom props 👇🏼
    // ...other
  } = props;

  return (
    <SnackbarContent ref={ref} role="alert">
      <Alert
        severity="warning"
        sx={{ width: '100%' }}
        onClose={() => {
          closeSnackbar(id);
        }}
      >
        {message}
      </Alert>
    </SnackbarContent>
  );
});
